import Logo from '~/assets/images/logo.png'

export default function Navigation() {
    return (
        <nav className="max-w-7xl mx-auto flex items-center justify-between max-h-[70px] px-6 lg:pl-16">
            <a href="https://xaman.app" className="py-6 h-full block">
                <img src={Logo} className="h-5" />
            </a>
            <ul className="py-6 hidden sm:flex ">
                <li className=""><a className="bg-brand-blue text-white font-bold px-4 py-2 rounded-lg leading-[156%] h-[40px]" href="https://xaman.app" target="_blank">Xaman.app</a></li>
            </ul>
        </nav>
    )
};
